module.exports = __webpack_public_path__ + "static/media/call_with_charles_nye.069ea669.jpg";